import React, { useState, useRef, useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  Typography,
  TextField,
  RadioGroup,
  Radio,
  Checkbox,
  InputLabel,
  Button,
  Box,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { fetchSuppliersByCompanyId } from "../../../../redux/orderSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Country, State, City } from "country-state-city";
import { updateCompanyAPI, updatePendingCompany } from "../../../../redux/adminSlice";

export const ADD_EDIT_LOCATION_CONTACT = yup.object().shape({
  companyName: yup.string().required("Company Name cannot be empty."),
  companyUrl: yup.string().required("Company URL is required."),
  companyTypeId: yup.string().required("Company Tyoe is required."),

  // export: yup.boolean().oneOf([true], 'Export'),
  description: yup.string().required("Company Description is required."),
});
const EditPendingContact = ({
  onSubmit,
  handleStepChange,
  actionType,
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { createdDate, modifiedDate, rejectedReason,rejectedDate,isActive, companyLogo,user,...rest } = location.state?.pendingCompanyDetails || {};
  delete rest.createdDate;
  delete rest.modifiedDate;
  delete rest.rejectedReason;
  delete rest.rejectedDate;
  delete rest.isActive;
  delete rest.companyLogo;
  delete rest.user;
  delete rest.firstName;
  delete rest.lastName;
  delete rest.prefix;
  const initialValues = location.state?.pendingCompanyDetails || {};
  const { loading } = useSelector((state) => state.order);
  const [countries, setCountries] = useState([]);
  const [selectedISD, setSelectedISD] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    const fetchCountries = async () => {
      const countriesWithISD = Country.getAllCountries().map((country) => ({
        code: country.phonecode,
        name: country.name,
      }));

      setCountries(countriesWithISD);
    };
    fetchCountries();
  }, [dispatch]);

  useEffect(() => {
    const fetchCountries = async () => {
      const countriesWithISD = Country.getAllCountries().map((country) => ({
        code: country.phonecode,
        name: country.name,
      }));

      setCountries(countriesWithISD);
    };
    fetchCountries();
  }, [dispatch]);
  const handleEditContactSubmit = (values) => {
    console.log("handleEditContactSubmit", values);
    const companyData = values
    dispatch(updatePendingCompany(companyData))
      .then((response) => {
        const companyDetails = response.payload

        if (companyDetails.success === true) {
          navigate(-1);
        } 
      })
      .catch((error) => {
        console.error("Fetching user details error:", error);
      });
    // navigate(-1)
  };
  return (
    <>
      <div className={className}>
      <div className="main-content">
                    <nav aria-label="breadcrumb" className="bread-box">
                        <div>
                            <h1 className="fprimary">
                                {location.state?.actionType === "edit" ? "Edit company" : "Add company"}
                            </h1>
                            <h5 className="">
                                {location.state?.actionType === "edit" ? "Edit" : "Add"} Company details to create
                                a new company
                            </h5>
                        </div>
                        <div>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="#">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    {location.state?.actionType === "edit" ? "Edit" : "Add"} Company
                                </li>
                            </ol>
                        </div>
                    </nav>
                    <div className="card mt-3 bg-stage">
        {actionType === "edit" && (
          <div className="ps-4 pe-4">
            <h1 className="fprimary">Contact Details</h1>
          </div>
        )}
        <Formik
          initialValues={{
            isdCode: initialValues?.isdCode === null ? "" : initialValues?.isdCode,
            phoneNumber: initialValues.phoneNumber || "",
            additionalIsdCode: initialValues?.additionalIsdCode === null ? "" : initialValues?.additionalIsdCode,
            additionalPhone: initialValues.additionalPhone || "",
            emailAddress: initialValues.emailAddress || "",
            additionalEmail: initialValues?.additionalEmail === null ? "" : initialValues?.additionalEmail,
            awards: initialValues.awards === null ? "" : initialValues?.awards,
            gst: initialValues.gst || "",
            ...rest,
          }}
          enableReinitialize={true}
          // validationSchema={ADD_EDIT_LOCATION_CONTACT}
          onSubmit={(values, { setSubmitting }) => {
            // console.log("Submitting form with values:", values);
            if (location.state?.actionType === "edit") {
              // dispatch(editBusinessUnit({ editedBusinessUnitData: values }));
              handleEditContactSubmit({ ...values });
            }

            // onSubmit(values);
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            touched,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="card-body m-3">
                <div className="row">
                  {/* <div className="col-md-4 cs-form mb-3">
                        <TextField
                            label={t('companyProfile.companyName')}
                            className='md-input'
                            name='companyName'
                            value={values.companyName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.companyName}
                            helperText={errors.companyName}
                        />
                    </div> */}
                  {/* <div className="col-md-2 cs-form mb-2"> */}
                  {/* <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        className='md-input'
                                        options={ISDList}
                                        getOptionLabel={(option) => option.label || ''}
                                        value={ISDList.find(option => option.value === values.isdCode) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({ target: { name: 'isdCode', value: newValue?.value || '' } });
                                        }}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={t('companyProfile.isd_code')}
                                                error={touched.isdCode && Boolean(errors.isdCode)}
                                                helperText={touched.isdCode && errors.isdCode}
                                            />
                                        )}
                                    /> */}
                  <div className="col-md-2 cs-form mb-3">
                    <FormControl fullWidth>
                      <Autocomplete
                        id="isdCode"
                        options={countries}
                        value={
                          countries.find(
                            (country) => country.code === values.isdCode
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          setFieldValue(
                            "isdCode",
                            newValue ? newValue.code : ""
                          );
                        }}
                        getOptionLabel={(option) => option.code}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="ISD"
                            variant="outlined"
                            error={touched.isdCode && Boolean(errors.isdCode)}
                            helperText={touched.isdCode && errors.isdCode}
                          />
                        )}
                      />
                    </FormControl>
                  </div>
                  {/* </div> */}
                  <div className="col-md-4 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.phone")}
                      className="md-input"
                      name="phoneNumber"
                      value={values.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.phoneNumber}
                      helperText={errors.phoneNumber}
                    />
                  </div>
                  <div className="col-md-2 cs-form mb-3">
                    <FormControl fullWidth>
                      <Autocomplete
                        id="additionalIsdCode"
                        options={countries}
                        value={
                          countries.find(
                            (country) =>
                              country.code === values.additionalIsdCode
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          setFieldValue(
                            "additionalIsdCode",
                            newValue ? newValue.code : ""
                          );
                        }}
                        getOptionLabel={(option) => option.code}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Addtional ISD"
                            variant="outlined"
                            error={
                              touched.additionalIsdCode &&
                              Boolean(errors.additionalIsdCode)
                            }
                            helperText={
                              touched.additionalIsdCode &&
                              errors.additionalIsdCode
                            }
                          />
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-md-4 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.additionalPhone")}
                      className="md-input"
                      name="additionalPhone"
                      value={values.additionalPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.additionalPhone}
                      helperText={errors.additionalPhone}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.email")}
                      className="md-input"
                      name="emailAddress"
                      value={values.emailAddress}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.emailAddress}
                      helperText={errors.emailAddress}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.additionalEmail")}
                      className="md-input"
                      name="additionalEmail"
                      value={values.additionalEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.additionalEmail}
                      helperText={errors.additionalEmail}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.gstIbr")}
                      className="md-input"
                      name="gst"
                      value={values.gst}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.gst}
                      helperText={errors.gst}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.awards")}
                      className="md-input"
                      name="awards"
                      value={values.awards}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.awards}
                      helperText={errors.awards}
                    />
                  </div>

                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-light grey-btn lg-btn"
                      onClick={() => navigate(-1)}
                    >
                      {t("createOrder.back")}
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary greeen-btn lg-btn lg-btn"
                      variant="contained"
                      disabled={loading}
                    >
                      {/* {loading ? 'Submitting...' : 'Submit'} */}
                      {location.state?.actionType !== "edit"
                        ? "Next"
                        : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      </div>
      </div>
    </>
  );
};

export default EditPendingContact;
